/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { Button } from '@chakra-ui/react'
export type BaseBgColor = 'primary' | 'secondary' | 'danger' | 'transparent' | 'light'

interface ButtonOption {
  isDisable?: boolean
  onClick?: (e: any) => void
  customBgColor: string
  textColor?: string
  children?: React.ReactNode
  width?: string
  height?: string
  variant?: string
  type?: 'button' | 'reset' | 'submit'
  fontSize?: string
  borderRadius?: string
  form?: string
  fontFamily?: string
  ml?: string
}

function ButtonChakra({
  isDisable,
  onClick,
  textColor,
  customBgColor,
  children,
  width,
  height,
  variant,
  type,
  fontSize,
  borderRadius,
  form,
  fontFamily,
  ml
}: ButtonOption): JSX.Element {
  return (
    <Button
      ml={ml}
      width={width}
      height={height}
      color={textColor}
      type={type}
      variant={variant}
      fontSize={fontSize}
      borderRadius={borderRadius}
      background={customBgColor}
      isDisabled={isDisable}
      form={form}
      onClick={onClick}
      fontFamily={fontFamily}
    >
      {children}
    </Button>
  )
}

ButtonChakra.defaultProps = {
  width: '100%',
  height: '40px',
  type: 'submit',
  fontSize: '18px',
  borderRadius: '8px',
  isDisable: false,
  customBgColor: '',
  fontFamily: 'DBSathorn',
  textColor: ''
}

export default ButtonChakra
